var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-video-player"},[_c('video',{ref:"video",attrs:{"controls":"","src":_vm.src,"poster":_vm.poster}})])
}
var staticRenderFns = []

export { render, staticRenderFns }